export const IS_D2NA_DOMAIN = /^(.+\.)?d2na.com$/.test(location.hostname);
export const IS_LOCALHOST = window.location.hostname === 'ejnlabs-local.ejnlabs.com';
